import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ThemeContext } from 'styled-components'

// ui-kit
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import Text from '@navent-jobs/ui-kit/components/text'

// mixins
import { PreguntasContainer, Title, TitleWrapper, TitleContent, CustomIcon, Divider } from './mixins'

interface PreguntasProps {
  setVisibleModalPreguntasPendientes: () => void
  autopostulado?: boolean
}

const Component = ({ setVisibleModalPreguntasPendientes, autopostulado }: PreguntasProps) => {
  const { t } = useTranslation()
  const { colors } = useContext<{ colors }>(ThemeContext)

  return (
    <>
      <PreguntasContainer autopostulado={autopostulado} onClick={setVisibleModalPreguntasPendientes}>
        <TitleWrapper>
          <TitleContent>
            <CustomIcon color={colors.danger.normal} name="icon-light-info" size="16" />
            <Title>
              <Text size="md" variant="danger" fontWeight="semibold">
                {t('postulaciones.preguntas.title')}
              </Text>
            </Title>
          </TitleContent>
          <Icon name="icon-light-caret-right" size="16" color={colors.grey84} />
        </TitleWrapper>
        <Text size="sm" variant="gray60">
          {t('postulaciones.preguntas.subtitle')}
        </Text>
      </PreguntasContainer>
      {!autopostulado && <Divider />}
    </>
  )
}

export default Component
